import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Bem from 'bemHelper';
import numDesc from 'helpers/numDesc';
import { I18nHoc, Trans } from 'helpers/i18n';
import Row, { Col } from 'components/row';
import Icon, { iconTypes } from 'components/icon';

import translates from '../how-we-calculate-score-i18n';

const classes = new Bem('blockHowWeCalculate');

@I18nHoc(translates())
export default class HowWeCalculateBlock extends Component {
  static propTypes = {
    className: PropTypes.string,
    topic: PropTypes.string,
    countCondition: PropTypes.number,
    topProjects: PropTypes.shape({})
  };

  render() {
    const { i18n } = this;
    const { className, topic, countCondition, topProjects = {} } = this.props;
    const topRating = get(topProjects, 'data[0].points.investorConfidence.all');
    const countConditionTxt = numDesc(
      countCondition,
      i18n('parameter'),
      i18n('parameterDeclination'),
      i18n('parameterMultiple')
    );

    return (
      <div {...classes({ extra: className })}>
        <Row {...classes('row', 'block')} mtColumn mpColumn>
          <Col {...classes('col', 'info')} allPr={0}>
            <div {...classes('text', 'h1')}><h1 children={topic || i18n('howWeCalculateScoreH1')} /></div>
            <Trans lang="ru">
              <ul {...classes('list')}>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children={`Индекс надёжности новостройки считаем по авторской методике, основанной на анализе данных о новостройках и застройщиках, взятых из государственных реестров, предоставленных застройщиками, рассчитанных самостоятельно и данных открытых источников. Всего ${countConditionTxt}.`} />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Процесс и результат оценки отображается в детальном отчёте, который позволяет убедиться в справедливости Индекса надёжности в любой момент. Таким образом, мы обеспечиваем его прозрачность и невозможность манипуляций." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'separatorLeft')}>
                    <p {...classes('text')} children="Значение Индекса надёжности формируется из суммы оценок всех пунктов экспертизы." />
                  </div>
                </li>
              </ul>
            </Trans>
            <Trans lang="ua">
              <ul {...classes('list')}>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children={`Індекс надійності новобудови рахуємо за авторською методикою, заснованою на аналізі даних про новобудови і забудовників, взятих із державних реєстрів, наданих забудовниками, розрахованих самостійно і даних відкритих джерел. Усього ${countConditionTxt}.`} />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description')}>
                    <p {...classes('text')} children="Процес і результат оцінки відображається в детальному звіті, який дозволяє переконатися в справедливості Індексу надійності в будь-який момент. Таким чином, ми забезпечуємо його прозорість і неможливість маніпуляцій." />
                  </div>
                </li>
                <li {...classes('listItem')}>
                  <div {...classes('description', 'separatorLeft')}>
                    <p {...classes('text')} children="Значення Індексу надійності формується з суми оцінок усіх пунктів експертизи." />
                  </div>
                </li>
              </ul>
            </Trans>
            <div {...classes('listAfter')}>
              <div {...classes('points')}>
                <Icon {...classes('icon', 'points highLevel')} type={iconTypes.bc} />
                <div {...classes('pointsText')}>
                  <span {...classes('text', 'points')} children={topRating} />
                  <span {...classes('text', 'pointsAll')} children={i18n('scoreMaximum')} />
                </div>
              </div>
              <div {...classes('points')}>
                <Icon {...classes('icon', 'points lowLevel')} type={iconTypes.bc} />
                <div {...classes('pointsText')}>
                  <span {...classes('text', 'points')} children={i18n('scoreMinimumLower')} />
                  <span {...classes('text', 'pointsAll')} children={i18n('scoreMinimum')} />
                </div>
              </div>
            </div>
          </Col>
          <Col {...classes('col', 'img')} allPr={0}>
            <div {...classes('imgContainer')}>
              <img {...classes('img')} src={i18n('imgPDF1')} alt={i18n('room')} loading="lazy" decoding="async" />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
